import { tv } from 'tailwind-variants'

export const stageEmailVariants = tv({
  slots: {
    container: 'flex flex-col ml-60 space-y-6',
    title: 'text-h1 font-bold mb-mili',
    subtitle: 'text-base text-medium',
    iconHint: 'flex flex-row gap-1 mt-mili text-deca items-center',
    buttonLoading: 'flex flex-row items-center gap-mili',
    icon: 'flex items-center text-deca'
  }
})
